module.exports = __webpack_public_path__ + "img/too_many_events.87d6326a.svg";